var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-menu',{staticClass:"scroll",attrs:{"menu":_vm.menu,"theme":"white-theme"}})}
var staticRenderFns = []

export { render, staticRenderFns }